<kt-base-modal [title]="'Breaks'">
  <div modal-body>
    <div class="shift-breaks-min-height">
      <ng-container *ngFor="let break of breaks">
        <div class="mb-2" *ngIf="break?.shift_break_type === breakTypeEnum.RestBreak">
          <div class="form-group w-100 ">
           
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text px-3 py-2">
                  <svg-icon class="svg_icon30x30 d-inline " src="assets/media/iq-svg/without_circle/icon_set_2/on_break.svg"></svg-icon>
                </span>
              </div>
              <div style="height: 80px;" rows="3" class="form-control" disabled>
                
             <div> <h5>  {{break?.shift_break_fix_time_enable ? 'Scheduled': 'Unscheduled'}} Rest Break (Paid)&#10; </h5></div>  
                <div> Duration:- {{break?.shift_break_total_time + ' Min'}}</div>
                {{ break?.shift_break_fix_time_enable ? (break.shift_break_start_date | TimezoneDateTime) + '-' + (break.shift_break_end_date | TimezoneDateTime) : ''}}</div>
            </div>
          </div>
        </div>
        <!-- Meal Break -->
        <div class="mb-2" *ngIf="break?.shift_break_type === breakTypeEnum.MealBreak">
          <div class="form-group w-100 ">
           
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text px-3 py-2">
                  <svg-icon class="svg_icon30x30 d-inline " src="assets/media/iq-svg/without_circle/icon_set_5/meal_break.svg"></svg-icon>
                </span>
              </div>
              <div style="height: 80px;"  rows="3" class="form-control" disabled>
                
                <div> <h5>  {{break?.shift_break_fix_time_enable ? 'Scheduled': 'Unscheduled'}}    Meal Break (UnPaid)</h5></div>  
                <div>Duration:- {{break?.shift_break_total_time + ' Min'}} </div>
                {{ break?.shift_break_fix_time_enable ? (break.shift_break_start_date | TimezoneDateTime) + '-' + (break.shift_break_end_date | TimezoneDateTime): ''}}
          </div>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="h6 bg-light d-flex justify-content-center align-items-center m-3 p-3" *ngIf="!breaks?.length">
        <ng-container>
          <kt-no-record-found [noRecordFound]="noRecordFound"></kt-no-record-found>
         </ng-container>
      </div>
    </div>
    <div class="d-flex modal-footer justify-content-start">
      <kt-button [buttonConfig]="buttonConfig.CLOSE_BUTTON_CONFIG" (buttonClick)="activeModal.close()">
      </kt-button>
    </div>
  </div>
</kt-base-modal>